<template>
    <div id="calculator" class="calculator p-5">
        <b-form>
            <b-row>
                <b-col md="6">
                    <label for="price">Purchase price</label>
                    <b-form-input type="number" name="price" class="currency" v-model.number="homeValue"/>
                </b-col>
                <b-col md="6">
                    <label for="down-payment">Down payment</label>
                    <b-form-input type="number" name="down-payment" class="currency" step="10000" v-model.number="downPayment"/>
                </b-col>
            </b-row>
            <b-row>
                <b-col md="6">
                    <label for="mortgage_period">Mortgage Period</label>
                    <b-form-select v-model="amortization" :options="mortgage_periods"></b-form-select>
                </b-col>
                <b-col md="6">
                    <label for="interestRate">Rate</label>
                    <b-form-input type="number" name="interestRate" v-model="interestRate"/>
                </b-col>
            </b-row>
            <b-row>
                <b-col md="6">
                    <label>Payment Frequency: </label>
                    <b-form-select class="form-control" v-model="paymentSelection">
                        <option v-for="payment, key in paymentPeriod" :value="key">{{key}}</option>
                    </b-form-select>
                </b-col>
            </b-row>
            <b-row>
                <b-col md="12" class="text-center mt-5">
                    <div class="payment"><strong>{{ paymentSelection }} Payment:</strong> {{ this.currencyFormat(payment) }}</div>
                    <div class="totalCost"> <strong>Total Cost of Mortgage:</strong> {{ this.currencyFormat(totalCostOfMortgage) }} </div>
                    <div class="totalInterest"> <strong>Total Interest Paid:</strong> {{ this.currencyFormat(totalInterestPaid) }}</div>
                </b-col>
            </b-row>
        </b-form>
    </div>
</template>

<script>
export default {
    name: 'calculator',
    props: {
        homeValue: {
            type: Number
        },
    },
    data() {
        return {
            downPayment: this.homeValue * .20,
            length: this.numPaymentsPerYear,
            interestRate: 4.25,
            amortization: 30,
            mortgage_periods:
                [
                    {value: 10, text: 10},
                    {value: 15, text: 15},
                    {value: 25, text: 25},
                    {value: 20, text: 20},
                    {value: 30, text: 30},
                    {value: 40, text: 40},
                ],
            paymentPeriod: {
                'Monthly': {npy: 12},
                'Semi-Monthly': {npy: 12 * 2},
                'Bi-Weekly': {npy: 365.25 / 7 / 2},
                'Weekly': {npy: 365.25 / 7}
            },
            paymentSelection: 'Monthly',
        }
    },
    methods: {
        currencyFormat(num) {
            return "$" + num.toFixed(0).replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,");
        }
    },
    computed: {
        interest: function () {
            return this.interestRate / 100;
        },
        principal: function () {
            return this.homeValue - this.downPayment
        },
        numPayments: function () {
            return this.amortization * this.numPaymentsPerYear
        },
        numPaymentsPerYear: function () {
            return this.paymentPeriod[this.paymentSelection].npy
        },
        interestPerPayment: function () {
            return this.interest / this.numPaymentsPerYear
        },
        payment: function () {
            var temp = Math.pow(1 + this.interestPerPayment, this.numPayments)
            var p = this.principal * this.interestPerPayment * temp / (temp - 1)
            return p;
        },
        totalCostOfMortgage: function () {
            return this.payment * this.numPayments;
        },
        totalInterestPaid: function () {
            return this.totalCostOfMortgage - this.principal;
        },
    },
}

</script>
